export const createFieldProps = (field) => ({
	id: `section_one-${field?.id}`.replaceAll('/', '-'),
	errorId: `section_${field?.id}`,
	label: field?.title,
	autoCapitalize: field?.autocapitalize,
	autoComplete: field?.autocomplete,
	errorMessage: field?.errorMessage,
	required: field?.required,
	placeholder: field?.placeholder,
	className: `wc-block-components-address-form__${field?.id}`.replaceAll('/', '-'),
	options: field?.options
		? Object.values(field.options).map((option) => ({
				value: option.key,
				label: option.text,
		  }))
		: [],
	...field?.attributes,
});

export const createCheckboxFieldProps = (fieldProps) => {
	const {
		errorId,
		errorMessage,
		autoCapitalize,
		autoComplete,
		placeholder,
		...rest
	} = fieldProps;
	return rest;
};